import { Box, Stack, useTheme } from "@mui/material";
import { mdHeight } from "components/AppBar";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useThemeGreyBackgroundColor } from "hooks/useThemeGreyBackgroundColor";
import { useCallback, useEffect, useState, type ReactNode } from "react";
import { useParams } from "react-router-dom";

import { ScoutChat } from "./Chat";
import { ScoutToolbar } from "./ScoutToolbar";

const SCROLLBAR_GUTTER_WIDTH = "16px";

export function Scout() {
  const backgroundColor = useThemeGreyBackgroundColor();
  const theme = useTheme();
  const { conversationId } = useParams();
  const [hasMessages, setHasMessages] = useState(false);
  const [conversationTitle, setConversationTitle] = useState<string | undefined>();
  const handleHasMessagesChange = useCallback((nextHasMessages: boolean) => {
    setHasMessages(nextHasMessages);
  }, []);
  const handleConversationTitleChange = useCallback((nextTitle: string | undefined) => {
    setConversationTitle(nextTitle);
  }, []);
  useBreadcrumb({ label: "Encamp Scout" });

  useEffect(() => {
    setHasMessages(false);
    setConversationTitle(undefined);
  }, [conversationId]);

  return (
    <Stack
      sx={{
        position: "relative",
        width: "100%",
        height: `calc(100vh - ${theme.spacing(mdHeight)})`,
        overflow: "hidden",
        backgroundColor,
      }}
    >
      <ScoutToolbarOverlay backgroundColor={backgroundColor}>
        <ScoutToolbar
          conversationTitle={conversationTitle}
          showLogo={Boolean(conversationId) || hasMessages}
          showTitle={Boolean(conversationId) || hasMessages}
        />
      </ScoutToolbarOverlay>
      <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
        <ScoutChat
          onConversationTitleChange={handleConversationTitleChange}
          onHasMessagesChange={handleHasMessagesChange}
        />
      </Box>
    </Stack>
  );
}

function ScoutToolbarOverlay({
  backgroundColor,
  children,
}: {
  backgroundColor: string;
  children: ReactNode;
}) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: SCROLLBAR_GUTTER_WIDTH,
        zIndex: 2,
        backgroundColor,
        pointerEvents: "none",
      }}
    >
      {children}
    </Box>
  );
}
